import * as React from "react";
import StoreCard from "../store-card";
import SearchField from "../search-field";
import Loader from "../map-loader";
const _ = require('lodash');
export default class StoreList extends React.Component {
    constructor(props) {
        super(props);
        this.toggleFilter = () => {
            this.setState({ toggle: !this.state.toggle });
        };
        this.getGeoLocation = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(this.props.getLocation);
            }
        };
        this.getPills = () => {
            let pills = [];
            _.forOwn(this.props.amenitesFilter, (value, key) => {
                if (value) {
                    pills.push(key);
                }
            });
            return pills;
        };
        this.handleKeyPress = (event) => {
            if (event.key == 'Enter') {
                this.props.updateSearchText(event.target.value);
            }
        };
        this.addressKeyPress = (event) => {
            if (event.key == 'Enter') {
                this.props.updateAddressText(event.target.value);
            }
        };
        this.state = {
            toggle: false
        };
    }
    render() {
        const stores = this.props.stores.map((store, index) => {
            return React.createElement(StoreCard, { store: store, key: index, selected: this.props.selected === index.toString(), storeIndex: index, updateSelected: this.props.updateSelected, MarkerClick: this.props.MarkerClick });
        });
        const filterObjs = [
            { name: "Special Events Ordering", value: "SpecialEventsOrdering" },
            { name: "On Site Special Events", value: "OnSiteSpecialEvents" },
            { name: "Keg Sales", value: "KegSales" },
            { name: "On Site Kitchen", value: "OnSiteKitchen" },
            { name: "Delivery Service", value: "DeliveryService" },
            { name: "Special Ordering", value: "SpecialOrdering" },
            { name: "Online Ordering", value: "OnlineOrdering" },
            { name: "Sommelier On Staff", value: "SommelierOnStaff" },
            { name: "Licensee Sales", value: "LicenseeSales" },
        ];
        const filterOptions = React.createElement("div", { className: "filter-options" }, filterObjs.map((filter, index) => {
            return React.createElement(SearchField, { key: index, selected: this.props.amenitesFilter[filter.value], onClick: () => { this.props.updateFilter(filter.value); }, label: filter.name });
        }));
        const filtertext = {
            SpecialEventsOrdering: "Special Events Ordering",
            OnSiteSpecialEvents: "On Site Special Events",
            KegSales: "Keg Sales",
            OnSiteKitchen: "On Site Kitchen",
            DeliveryService: "Delivery Service",
            SpecialOrdering: "Special Ordering",
            OnlineOrdering: "Online Ordering",
            SommelierOnStaff: "Sommelier On Staff",
            LicenseeSales: "Licensee Sales",
        };
        let pillsStr = this.getPills();
        let style = {
            display: pillsStr.length > 0 ? "flex" : "none",
            marginTop: "1rem"
        };
        let pills = pillsStr.map((pill, index) => {
            return React.createElement("li", { key: index, className: "filter-pills__list__item" },
                React.createElement("button", { className: "pill" },
                    React.createElement("span", null, filtertext[pill]),
                    React.createElement("i", { onClick: () => { this.props.updateFilter(pill); }, className: "fa fa-times", "aria-hidden": "true" })));
        });
        return (React.createElement("div", { className: "store-list" },
            React.createElement("div", { className: "store-filter" },
                React.createElement("div", { className: "location-container" }, navigator.geolocation ? (React.createElement("span", null,
                    React.createElement("i", { className: "fa fa-location-arrow store-location", onClick: this.getGeoLocation }),
                    React.createElement("span", null, "Get Location"))) : null),
                React.createElement("div", { className: "search-results-bar postal-code-bar" },
                    React.createElement("input", { placeholder: "Enter Address, Postal Code, or Landmark", onKeyPress: this.addressKeyPress, onBlur: (e) => { this.props.updateAddressText(e.target.value); } }),
                    React.createElement("i", { className: "fa fa-search" })),
                React.createElement("div", { className: "filter-category" },
                    React.createElement("div", { className: this.state.toggle ? "selected filter-button" : "filter-button", onClick: this.toggleFilter }, "FILTER"),
                    React.createElement(Loader, null)),
                this.state.toggle ?
                    React.createElement("div", null,
                        React.createElement("div", { className: "search-results-bar" },
                            React.createElement("input", { placeholder: "Search by store name", onKeyPress: this.handleKeyPress, onBlur: (e) => { this.props.updateSearchText(e.target.value); } }),
                            React.createElement("i", { className: "fa fa-search" })),
                        filterOptions) :
                    null,
                React.createElement("nav", { className: "filter-pills", style: style },
                    React.createElement("span", { className: "filter-pills__label" }, "Filters:"),
                    React.createElement("ul", { className: "filter-pills__list" },
                        pills,
                        React.createElement("li", { className: "filter-pills__list__item" },
                            React.createElement("button", { className: "clear-all", onClick: () => { this.props.clearFilter(); } }, "Clear All"))))),
            stores));
    }
}
;
//# sourceMappingURL=store-list.js.map